<template>
  <div>
    <b-row>
      <b-col>
        <success-fade-alert ref="successFadeAlert" :msg="alert.success" />
        <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
      </b-col>
    </b-row>
    <h1 v-if="id == undefined">Criar Rota</h1>
    <h1 v-else>Editar Rota</h1>
    <router-link :to="`/checklist/route/list`">
      <b-button size="sm"> Voltar </b-button>
    </router-link>

    <b-row class="mt-4">
      <b-col cols="6">
        <RouteCrud :route.sync="route" />
      </b-col>
    </b-row>

    <b-button @click="save"> Salvar </b-button>
  </div>
</template>

<script>
export default {
  name: "RouteSave",
  props: {
    id: String,
  },
  components: {
    RouteCrud: () => import("@/components_rms/RoutesCrud.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Rota salva com sucesso",
      },
      route: {
        id: 0,
        active: true,
        name: "",
        originCityId: 0,
        originStateId: 0,
        originCountryId: 0,
        destinationCityId: 0,
        destinationStateId: 0,
        destinationCountryId: 0,
        serviceTaker: "",
        sender: "",
        receiver: "",
      },
    };
  },
  methods: {
    loadData() {},
    save() {},
  },
  computed: {
    // Your computed properties here
  },
  mounted() {
    if (this.id != undefined) {
      this.loadData();
    }
  },
};
</script>

<style scoped>
/* Your styles here */
</style>